import { createContext, useContext } from 'react'

export const SearchCwvContext = createContext<{ searchCwv: string }>({
  searchCwv: '',
})

export const useSearchComponentsContext = () => {
  const context = useContext(SearchCwvContext)!

  return context
}
